'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface LiveTrackingMapProps {
  deliveryLat: number;
  deliveryLng: number;
  destinationAddress: string;
}

const LiveTrackingMap = ({
  deliveryLat,
  deliveryLng,
  destinationAddress,
}: LiveTrackingMapProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="bg-card rounded-lg shadow-elevation-md p-6">
        <div className="animate-pulse">
          <div className="h-6 bg-muted rounded w-1/3 mb-4"></div>
          <div className="h-64 bg-muted rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg shadow-elevation-md p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading text-xl font-semibold text-foreground">Live Tracking</h2>
        <div className="flex items-center gap-2 px-3 py-1.5 bg-success/10 text-success rounded-full">
          <span className="w-2 h-2 bg-success rounded-full animate-pulse"></span>
          <span className="text-xs font-medium">Live</span>
        </div>
      </div>

      <div className="relative w-full h-64 md:h-80 rounded-lg overflow-hidden bg-muted">
        <iframe
          width="100%"
          height="100%"
          loading="lazy"
          title={destinationAddress}
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps?q=${deliveryLat},${deliveryLng}&z=14&output=embed`}
          className="border-0"
        ></iframe>
      </div>

      <div className="mt-4 flex items-start gap-3 p-4 bg-muted rounded-lg">
        <Icon name="MapPinIcon" size={20} className="text-primary flex-shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-medium text-foreground mb-1">Delivery Location</p>
          <p className="text-sm text-muted-foreground">{destinationAddress}</p>
        </div>
      </div>
    </div>
  );
};

export default LiveTrackingMap;